/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/5/17
 * Copyright All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from 'selectors/tokenSelectors';
import tokenHelpers from 'support/tokenHelpers';

/**
 * A Route that routes to a given component given a valid token and redirects to the the sign in
 * page given no valid token.
 */
const PrivateRouteContainer = ({ component, path, store, ...rest }) => (
  <Route
    path={path}
    render={props => (
      tokenHelpers.isValid(getToken(store.getState())) ?
        React.createElement(component, props) :
        <Redirect to={{ pathname: '/sign-in' }} />
    )}
    rest={rest}
  />
);

PrivateRouteContainer.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  path: PropTypes.string.isRequired,
  store: PropTypes.shape({
    getState: PropTypes.func.isRequired,
  }).isRequired,
};

export default PrivateRouteContainer;
